import { render, staticRenderFns } from "./LectorsTemplate.vue?vue&type=template&id=2d617322&scoped=true"
import script from "./LectorsTemplate.vue?vue&type=script&lang=js"
export * from "./LectorsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d617322",
  null
  
)

export default component.exports